import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.privemobility.com/api';
const ANALYTICS_URL = `${API_BASE_URL}/analytics`;

class AnalyticsService {
  constructor() {
    this.sessionId = this.generateSessionId();
    this.userId = this.getUserId();
  }

  generateSessionId() {
    return `session_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
  }

  getUserId() {
    let userId = localStorage.getItem('userId');
    if (!userId) {
      userId = `user_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
      localStorage.setItem('userId', userId);
    }
    return userId;
  }

  async track(eventName, properties = {}) {
    const event = {
      eventType: eventName,
      userId: this.userId,
      sessionId: this.sessionId,
      timestamp: new Date().toISOString(),
      eventData: properties,
      metadata: {
        userAgent: navigator.userAgent,
        language: navigator.language,
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        referrer: document.referrer,
        url: window.location.href
      }
    };

    try {
      await axios.post(ANALYTICS_URL, event);
      // Event tracked successfully
    } catch (error) {
      console.error('Analytics error:', error);
    }
  }

  // Eventos específicos del flujo
  trackPageView(pageName) {
    this.track('page_view', { pageName });
  }

  trackSearch(searchParams) {
    this.track('search_performed', {
      pickupLocation: searchParams.pickupLocation,
      pickupDate: searchParams.pickupDate,
      returnDate: searchParams.returnDate,
      duration: this.calculateDuration(searchParams.pickupDate, searchParams.returnDate)
    });
  }

  trackVehicleView(vehicle) {
    this.track('vehicle_viewed', {
      vehicleId: vehicle.id,
      vehicleName: vehicle.name,
      vehicleCategory: vehicle.category,
      price: vehicle.price
    });
  }

  trackVehicleConsult(vehicle) {
    this.track('vehicle_consult_clicked', {
      vehicleId: vehicle.id,
      vehicleName: vehicle.name,
      price: vehicle.price
    });
  }

  trackInsuranceSelected(insuranceType, selected) {
    this.track('insurance_toggled', {
      insuranceType,
      selected
    });
  }

  trackAdditionalChanged(additionalType, quantity) {
    this.track('additional_changed', {
      additionalType,
      quantity
    });
  }

  trackPaymentMethodSelected(method) {
    this.track('payment_method_selected', {
      method
    });
  }

  trackFormFieldFilled(fieldName) {
    this.track('form_field_filled', {
      fieldName
    });
  }

  trackBookingAttempt(bookingData) {
    this.track('booking_attempt', {
      vehicle: bookingData.vehicle,
      insurances: bookingData.insurances,
      additionals: bookingData.additionals,
      paymentMethod: bookingData.paymentMethod,
      totalPrice: bookingData.totalPrice
    });
  }

  trackError(errorType, errorMessage) {
    this.track('error_occurred', {
      errorType,
      errorMessage
    });
  }

  calculateDuration(startDate, endDate) {
    if (!startDate || !endDate) return null;
    const start = new Date(startDate);
    const end = new Date(endDate);
    return Math.ceil((end - start) / (1000 * 60 * 60 * 24));
  }
}

export const analytics = new AnalyticsService();
